// Удалите импорт refreshSession, он не используется
import { supabase } from './supabaseCustomAuth'; // Импортируем из правильного файла

/**
 * Выполняет запрос к Supabase с автоматическим обновлением токена при ошибке 401
 */
export const fetchWithAuthRefresh = async (queryFn, maxRetries = 1) => {
  let retries = 0;
  
  while (retries <= maxRetries) {
    try {
      const result = await queryFn();
      return result;
    } catch (error) {
      // Если ошибка 401 и мы еще не превысили лимит попыток
      if (error.status === 401 && retries < maxRetries) {
        console.log('Token expired, refreshing session...');
        
        try {
          // Пытаемся обновить сессию
          const { error: refreshError } = await supabase.auth.refreshSession();
          if (refreshError) throw refreshError;
          
          console.log('Session refreshed successfully');
          retries++;
          // Повторяем запрос с новым токеном
          continue;
        } catch (refreshError) {
          console.error('Failed to refresh session:', refreshError);
          // Если не удалось обновить сессию, возвращаем ошибку
          throw error;
        }
      }
      
      // Другая ошибка или превышен лимит попыток
      throw error;
    }
  }
};

/**
 * Универсальная функция для получения данных из Supabase с обработкой 401
 */
export const fetchDataFromSupabase = async (table, query = {}, maxRetries = 1) => {
  return fetchWithAuthRefresh(async () => {
    let queryBuilder = supabase.from(table).select(query.select || '*');
    
    // Применяем фильтры
    if (query.filters) {
      for (const [key, value] of Object.entries(query.filters)) {
        queryBuilder = queryBuilder.eq(key, value);
      }
    }
    
    // Применяем сортировку
    if (query.orderBy) {
      queryBuilder = queryBuilder.order(query.orderBy.column, {
        ascending: query.orderBy.ascending !== false
      });
    }
    
    const { data, error } = await queryBuilder;
    
    if (error) throw error;
    return { data, error: null };
  }, maxRetries);
};